module.exports = __webpack_public_path__ + "img/one-way-flight.74c5ee17.svg";